import React, { Component } from 'react'
import ButtonAnimated from '../buttons/ButtonAnimated';

import FormInnerInput from './FormInnerInput';

class Form extends Component {

    state = {
        questions: [],
        answers: [],
        scoreData: [],
        scoreHeader: [],
        scores: [],
        disableInputs: false
    }

    componentDidMount() {
        // console.log('questiooooons', this.props.data?.values)
        // // if (this.props.data && this.props.data?.values && this.props.data?.values?.questions) {
        // //     // let scoreHeader=this.state.scoreHeader
        // //     // this.props.data?.values?.questions.forEach(el => {
        // //     //     scoreHeader.push(
        // //     //         { key: `${el.key}1`, id: `${el.id}1`, type: 'NumberInput', information: { disabled: false, label: "{{lang}}Number", placeholder: "{{lang}}Score" } }
        // //     //     )
        // //     // });
        // //     this.setState({ questions: this.props.data?.values?.questions, scoreHeader: this.props.data?.values.scoreHeader }, () => {
        // //     })
        // // }
        // console.log('this.props.collectionId', this.props)
        // // this.props.changeBackbtn(true)
        // // console.log('this.props.editForm', this.props.editForm)
        // if (this.props.editForm) {
        //     // console.log('newInquiryasdqqqqqqqqqq')
        //     this.props.setHeader({
        //         'toolbar': null,
        //         'showToolbar': false,
        //         topHeaderComponent: this.topHeaderComponent,
        //         title: '{{lang}}Edit Inquiry',
        //         // headerIdentityComponent: this.headerIdentityComponent,
        //         backAction: () => this.props.changeStage('form')
        //     })
        // }
        // else {
        //     this.props.setHeader({
        //         'toolbar': null,
        //         'showToolbar': false,
        //         topHeaderComponent: this.topHeaderComponent,
        //         title: '{{lang}}New Inquery',
        //         // headerIdentityComponent: this.headerIdentityComponent,
        //         backAction: () => this.props.changeStage('form')
        //     })
        // }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.showSubmitModal}
                    title='{{lang}}Submit'
                    icon='/assets/icons/arrow-right-white.svg'
                    // icon='/assets/icons/plus-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
            </div>
        )
    }

    showSubmitModal = () => {
        this.submitModal.showModal()
    }

    liveChange = (stage) => {
        // return
        if(this.form){

            let form = this.form.getForm()
            
            if (form != 'undefined') {
                this.props.changeValue(this.props.header.key,form.answers,this.props.extra,this.props.fullData,null, () => {
                    if (this.props.header.secondKey) {
                        if (Object.entries(form.scores).length > 0) {
                        // console.log('forrrrrrm', form)
                        this.props.changeValue(this.props.header.secondKey, form.scores ,this.props.extra,this.props.fullData,null, () => {
                 
                            // this.props.postRecord(() => {

                            // })
                        })
                    }
                } else {
                    // this.props.postRecord(() => {
                        
                    // })
                    
                }
            })
            
        }
        }
    }
    editNextStage = (stage) => {
        let form = this.form.getForm()
        this.props.postEditRecord(() => {
            if (form != 'undefined') {
                this.props.setData({ 'values.answers': form.answers }, () => {
                    if (this.props.hasScore) {
                        if (Object.entries(form.scores).length > 0) {
                            this.props.setData({ 'values.scores': form.scores })
                        }
                    }
                })
            }
        })
        // let rawData = this.state.formContent
        // if (rawData) {

        //     let questions = []
        //     rawData[0].pageContent[0].sectionContent.map((prop) => {
        //         prop.rowContent.map((element) => {
        //             questions.push(element)
        //         })
        //     })

        //     this.props.setData({ 'values.questions': questions }, () => {
        //         this.props.postEditRecord(() => {
        //             this.submitModal.hideModal()
        //         })
        //     })
        // }
    }
    // nextStage = (stage) => {
    //     let form = this.form.getForm()
    //     console.log('forrrrrrrrrm1', form)
    //     return
    //     let rawData = this.state.formContent
    //     console.log(rawData)
    //     if (rawData && rawData[0]?.pageContent && rawData[0]?.pageContent[0]) {
    //         let questions = []
    //         rawData[0].pageContent[0].sectionContent.map((prop) => {
    //             prop.rowContent.map((element) => {
    //                 questions.push({ ...element })
    //             })
    //         })

    //         this.props.setData({ 'values.questions': questions }, () => {
    //             this.props.postRecord(() => {
    //                 this.submitModal.hideModal()
    //             })
    //         })
    //     }
    // }

    setData = (key, value) => {
        this.setState({ [key]: value }, () => {
            let second = 0
        })
    }

    changeValue = (key, value) => {
        // console.log('changeValue')
        this.setState({ [key]: value }, () => {
            // if (this.state.public) {
            //     this.setState({ publicPermissions: '*' })
            // }
        })
    }

    onChangeAnswerSheet = (id, isOn) => {
        this.props.setData({ 'values.hasAnswerSheet': isOn }, () => {
        })
    }

    onChangeScore = (id, isOn) => {
      
        this.props.setData({ 'values.hasScore': isOn }, () => {
        })
    }


    onSeeAnswer = (id, isOn) => {
        this.props.setData({ 'values.seeAnswer': isOn }, () => {
        })
    }
    render() {
        let disableInputs = this.props.header.information.disabled

        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }
        let hub = this.props.initData?.hub
        variables.hub = hub
        variables.targetId = hub
        let searchTab = this.state.searchTab
        let correctionKey = this.props.header?.correctionKey
        let answerData = {}
        if(correctionKey){

            if(correctionKey.split('.').length>1){
                
                answerData = this.props.fullData[correctionKey.split('.')[0]] && this.props.fullData[correctionKey.split('.')[0]][correctionKey.split('.')[1]]
            }else{
                answerData = this.props.fullData[correctionKey]
                
            }
        }
let secondKey = this.props.header?.secondKey
let scoreData = {}
if(secondKey.split('.').length>1){

    scoreData = this.props.fullData[secondKey.split('.')[0]] && this.props.fullData[secondKey.split('.')[0]][secondKey.split('.')[1]]
    }else{
        scoreData = this.props.fullData[secondKey]
    
    }
let headersKey = this.props.header?.information?.headersKey
let headers = []
if(headersKey && this.props.fullData && Object.values(this.props.fullData).length>0){
    // console.log('headersKey.split',headersKey.split('.'));
   
if(headersKey.split('.').length>1){

headers = this.props.fullData[headersKey.split('.')[0]] && this.props.fullData[headersKey.split('.')[0]][headersKey.split('.')[1]]
}else{
    headers = this.props.fullData[headersKey]

}
}
        return (
            <div className='w-100 h-100'>
                <div className='pt-4 d-flex flex-column px-4 h-100 scroll-no-scrollbar' style={{}}>
                    {/* <p className='font-size-16 weight-700 pb-3'>{translate('Answers and Scores of Questions')}</p> */}
                   
                 
         
                        <div className='w-100 flexc pt-3'>
                            <FormInnerInput ref={el => this.form = el} liveChange={this.liveChange} initData={this.props.data} data={this.props.data} header={this.props.header} fullData={this.props.fullData} scoreData={scoreData} scoreInitData={scoreData} showCorrect={this.props.header.information.showCorrect} answerData={answerData} headers={headers} questions={headers} inputClass={'modern-input'} nopadding={true}  disableInputs={disableInputs} />
             
                        </div>
                </div>
                
            </div>
        )
    }
}

export default Form;